import { FunctionComponent } from "react";
import styled from "styled-components";
import Button from "../Button";
import Login from "../Login";
import { NavLink } from "react-router-dom";
import { useAuth, useUser } from "reactfire";

type Props = {};

const Logo = styled.div``;

const Links = styled.div`
  margin: auto;
  padding-top: 16px;
  padding-bottom: 20px;

  a {
    color: white;
    padding-bottom: 4px;
    text-decoration: none;
    font-size: 1.2rem;
    margin-right: 32px;

    &.active {
      border-bottom: 2px solid white;
    }

    &:last-child {
      margin-right: 0;
    }
  }
`;

const StyledHeader = styled.nav`
  display: flex;
  background: #0c151f;
`;

const Header: FunctionComponent<Props> = ({}) => {
  const auth = useAuth();
  const user = useUser();

  const links = [
    { href: "/", as: "/", text: "Home" },
    { href: "/roster", as: "/roster", text: "Roster" },
    { href: "/decks", as: "/decks", text: "Decks" },
  ];

  const onLogout = () => {
    auth.signOut();
  };

  return (
    <StyledHeader>
      <Logo></Logo>
      <Links>
        {links.map((link) => (
          <NavLink to={link.href} activeClassName="active" exact>
            {link.text}
          </NavLink>
        ))}

        {user.data && (
          <a onClick={onLogout}>
            <Button>Logout</Button>
          </a>
        )}

        {!user.data && (
          <a>
            <Login />
          </a>
        )}
      </Links>
    </StyledHeader>
  );
};

export default Header;
